import { sendGATracking } from "~/components/tracking/google-analytics/apis";

export const useTracking = () => {
  const trackImpression = (aiEngineRecommendId: string, topPicksEntityIds: string[]) => {
    sendGATracking({
      action: `Top Picks/inHouse/${aiEngineRecommendId}/Impression`,
      category: "Top Picks",
      label: topPicksEntityIds.join(","),
    });
  };

  const trackClick = (aiEngineRecommendId: string, entityId: string) => {
    sendGATracking({
      action: `Top Picks/inHouse/${aiEngineRecommendId}/Click`,
      category: "Top Picks",
      label: entityId,
    });
  };

  return {
    trackClick,
    trackImpression,
  };
};
